<template>
    <section class="subpage__content">
        <div class="subpage__inner">
            <div class="dashboard">
                <!-- NoData -->
                <div v-if="noStudyData">
                    <div class="boxRounded" style="background-color: #f7f7f7">
                        <mapChart :noStudyData="noStudyData" />
                    </div>
                    <div style="text-align: center; margin: 80px">
                        <CusButton :type="500" :label="`학습 홈으로 이동`" @onReturn="onHome" />
                    </div>
                </div>

                <!-- 상단_챠트 -->
                <div v-if="!noStudyData" class="panel__box gray">
                    <span class="mapTt30" style="color: #8e43f0"> </span>
                    <h3 class="subtitle">
                        {{ userName }}님은 <span class="bold color_primary">{{ curSP?.level }}레벨 {{ curSP?.lesson }}레슨</span>
                    </h3>
                    <p class="summary">출발점 {{ startSP?.level }}레벨 {{ startSP?.lesson }}레슨</p>
                    <mapChart v-if="startSP && curSP" :startLevel="startSP.level" :startLesson="startSP.lesson" :lesson="curSP.lesson" :level="curSP.level" />
                </div>
            </div>
            <!-- 오늘학습 -->
            <div v-if="!noStudyData" class="mg_top_80 today">
                <h3 class="subtitle">오늘 학습</h3>
                <div class="panel__box">
                    <div v-if="todayStudy?.todayLearningList?.length > 0">
                        <!-- <p class="mapTt30 textLayout">오늘 학습</p> -->
                        <!-- <StudyBox :topData="todayStudy" /> -->
                        <template v-for="(e, i) in todayStudy?.todayLearningList" :key="i">
                            <StNormal :is-top="true" :one="e" />
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- 학습기록 -->
        <div v-if="!noStudyData" class="mg_top_80 pd_top_80 study">
            <div class="subpage__inner">
                <h3 class="mg_bottom_32 subtitle">학습기록</h3>
                <div v-if="totalData">
                    <DateBox :totalData="totalData" />
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import Test1 from '@/views/testP/index.vue';
import StNormal from '@/views/userMapMain/components/StNormal.vue';
import StNormalBox from '@/views/userMapMain/components/StNormalBox.vue';
import DateBox from '@/views/userMapMain/components/DateBox.vue';
import CusButton from '@/components/widget/CusButton.vue';

import StudyBox from '@/views/userMap/components/studyBox.vue';
import StudyList from '@/views/userMap/components/studyList.vue';
import NoData from '@/views/userMap/components/noData.vue';
import { getKnowledgeMap } from '@/api/modules/user_map.js';
import { getUserInfo } from '@/api/modules/mypage';
import mapChart from '@/components/chart/mapChart.vue';
import cqBtnVue from '@/components/quasar/cqBtn.vue';
import { useRouter } from 'vue-router';
import { GlobalStore } from '@/store';

const gStore = GlobalStore();
const router = useRouter();

const noStudyData = ref(false);
// watch(noStudyData, (nnn, ooo) => {
//     console.log('--noStudyData noStudyData--', nnn);
// });
const isDisableBtn = ref(false);
const totalData = ref([]);
const todayStudy = ref();
const startSP = ref(null);
const curSP = ref(null);

const userName = ref();
const setUserInfo = async () => {
    const res = await getUserInfo(gStore.token);
    if (res && res.status === 200) {
        // console.log('--setUserInfo setUserInfo--');
        userName.value = res.data.data.studentName;
    }
};

const setGraphData = (spInfo) => {
    // const total = 3 * 96;
    // startSP.value = (spInfo.orgSpLevel - 1) * 96 + spInfo.orgSpLesson;
    // startSP.value = Math.round((100 / total) * point);
    // curSP.value = (spInfo.currentLevel - 1) * 96 + spInfo.currentLesson;
    startSP.value = {
        level: spInfo.orgSpLevel > 0 ? spInfo.orgSpLevel : 1,
        lesson: spInfo.orgSpLesson > 0 ? spInfo.orgSpLesson : 1,
    };
    if (spInfo.currentLevel > 3) {
        // 4레벨 넘어가면 마지막 레벨레슨으로 표기
        curSP.value = {
            level: 3,
            lesson: 96,
        };
    } else {
        curSP.value = {
            level: spInfo.currentLevel,
            lesson: spInfo.currentLesson,
        };
    } 
};
const setStudyData = async () => {
    const resMap = await getKnowledgeMap(gStore.token); 
    if (resMap)
        if (resMap.status === 200) {
            //NoData 오늘학습
            noStudyData.value = resMap.data.data.list.length < 1; 
            // 오늘학습
            todayStudy.value = structuredClone(resMap.data.data.todayLearning);
            // 그래프
            setGraphData(resMap.data.data.spInfo); 
            // 데이타 재정렬
            totalData.value = resMap.data.data.list
                .map((e) => {
                    return { ...e, date: Number(e.date.replaceAll('.', '')) };
                })
                .sort((a, b) => b.date - a.date)
                .map((e, i, arr) => {
                    // console.log('--totalData--e:', e);
                    const previous = arr[i - 1];
                    // const result = { ...e, date: previous && previous.date === e.date ? null : e.date.toString().slice(0, 4) + '.' + e.date.toString().slice(4, 6) + '.' + e.date.toString().slice(6, 8) };
                    // console.log('--totalData--result:', result);
                    // return result;
                    return { ...e, date: previous && previous === e.date ? null : e.date.toString().slice(0, 4) + '.' + e.date.toString().slice(4, 6) + '.' + e.date.toString().slice(6, 8) };
                });
 
        }
};

onMounted(() => {
    setUserInfo();
    setStudyData();
});

////////////////////////////----OnClick----////////////////////////////
const onContents = () => {
    isDisableBtn.value = true;
    router.push('/contents');
};
const onHome = () => {
    router.push('/learninghome');
};
</script>

<style scoped lang="scss">
.textLayout {
    margin: 0 2.5vmin;

    &.mapTt33 {
        margin: 0.83vmin 2.5vmin 1.33vmin;
    }
}
.roundedBtnOut {
    padding: 1.17vmin 3.33vmin;
    border-radius: 1.3vmin;
    border: 1px solid black;
    background-color: white;
}
.map__title {
    margin-top: 2vmin;
}

.content__box {
    margin-bottom: 6.42vmin;
}
</style>
